import React, { useEffect, useState } from 'react'
import { useTranslation } from '@/contexts/TranslationContext'

// Small PWA install button. Shows when `beforeinstallprompt` fires (Android/Chrome).
export default function PwaInstallButton() {
  const { t } = useTranslation()
  const [deferredPrompt, setDeferredPrompt] = useState<any>(null)
  const [supported, setSupported] = useState(false)

  useEffect(() => {
    const handler = (e: any) => {
      e.preventDefault()
      setDeferredPrompt(e)
      setSupported(true)
    }
    window.addEventListener('beforeinstallprompt', handler as EventListener)

    // If on iOS Safari we can still prompt user with instructions — detect here.
    const isIos = /iphone|ipad|ipod/i.test(window.navigator.userAgent)
    const isInStandalone = ('standalone' in window.navigator && (window.navigator as any).standalone)
    if (isIos && !isInStandalone) setSupported(true)

    return () => window.removeEventListener('beforeinstallprompt', handler as EventListener)
  }, [])

  const onInstall = async () => {
    if (deferredPrompt) {
      try {
        await deferredPrompt.prompt()
        const choice = await deferredPrompt.userChoice
        setDeferredPrompt(null)
        setSupported(false)
        return choice
      } catch (err) {
        console.error('PWA install prompt failed', err)
      }
    } else {
      // For iOS show a simple help fallback — keep it minimal here
      alert(t('install.pwa.iosHelp'))
    }
  }

  if (!supported) return null

  return (
    <button
      title={t('install.pwa.title')}
      onClick={onInstall}
      className="ml-3 inline-flex items-center px-3 py-1 text-sm font-medium text-gray-700 dark:text-gray-200 bg-gray-100 dark:bg-slate-800 rounded"
    >
      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 3v12m0 0l4-4m-4 4-4-4M21 12v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-6" />
      </svg>
      {t('install.pwa.label')}
    </button>
  )
}
